// extracted by mini-css-extract-plugin
module.exports = {"settings__field":"settings__settings__field___3CdcZ","settingsField":"settings__settings__field___3CdcZ","settings__label":"settings__settings__label___ZAfIc","settingsLabel":"settings__settings__label___ZAfIc","settings__options":"settings__settings__options___UD7Rl","settingsOptions":"settings__settings__options___UD7Rl"};
    if(module.hot) {
      // 1567920248354
      var cssReload = require("C:/Users/kpereira/WebstormProjects/clones/destiny-chalice-sim/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  